/** Pitchoune size is sold by 3. Checkout stays closed under 12 EUR (cents). */
export const PITCHOUNE_MIN_QTY = 3;
export const MIN_ORDER_CENTS = 1200;

export function minQtyForOptions(options: Array<string | null | undefined>, title = ''): number {
  const values = [...options, ...title.split('/')].map((value) => (value ?? '').trim().toLowerCase());
  return values.includes('pitchoune') ? PITCHOUNE_MIN_QTY : 1;
}

export function minQtyFromDataset(value: string | undefined): number {
  const parsed = Number.parseInt(value ?? '', 10);
  if (!Number.isFinite(parsed) || parsed < 1) return 1;
  return parsed;
}

/** 0 removes the line. A positive quantity under the floor snaps up to the floor. */
export function clampCartQty(value: number, min: number): number {
  if (!Number.isFinite(value) || value <= 0) return 0;
  if (min > 1 && value < min) return min;
  return value;
}

export function nextCartQty(current: number, delta: 1 | -1, min: number): number {
  if (delta > 0) return current + 1;
  const floor = current >= min && min > 1 ? min : 0;
  return Math.max(floor, current - 1);
}

export function canCheckout(totalCents: number, minimumCents = MIN_ORDER_CENTS): boolean {
  return totalCents >= minimumCents;
}

export function remainingCents(totalCents: number, minimumCents = MIN_ORDER_CENTS): number {
  return Math.max(0, minimumCents - totalCents);
}
